import Statistics from "../../../model/statistics/Statistics";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import { PageIds } from "../../PageIds";
import StatisticsContainerView from "./StatisticsContainerView";

export default class StatisticsPopupView extends ParentView {
    /**
     * @param {string} parentId
     * @param {Statistics} runStatistics
     * @param {Statistics} globalStatistics
     */
    constructor(parentId, runStatistics, globalStatistics) {
        super(parentId, PageIds.STATISTICS_POPUP);

        this.addView(new StatisticsContainerView(this.getElementId(), runStatistics, globalStatistics));
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {

        // <div id="statisticsPopup" class="popup-window-statistics" style="display: none;">

        const parentElement = Page.getElement(this.parentId);
        const statisticsPopup = Page.createElement('div', parentElement, this.getElementId(), 'popup-window-statistics');

        // <div class="popup-window-header">
        //   Statistics
        // </div>

        const statsHeader = Page.createElement('div', statisticsPopup, null, 'popup-window-header');
        statsHeader.innerHTML = 'Statistics';

        const thisRef = this;

        statsHeader.onclick = function () {
            thisRef.setViewVisible(false);
            return false;
        };

        this.setInitialVisibility(false);

        super.initializeView();
    }
}